const selectedFilters = {
    s: null,
};

let had_filters = false;

jQuery(($) => {
    const urlParams = window.location.search;
    const filters = new URLSearchParams(urlParams);

    for (const cat in selectedFilters) {
        if (filters.has(cat)) {
            had_filters = true;
            const val = filters.get(cat);
            setSelectedItem(val, cat);
        }
    }

    let searchTimeout;
    let previousRequest;

    $('#title-filter').on('keyup', function (e) {
        if (!had_filters) {
            had_filters = true;
        }

        const value = e.target.value;
        const category = $(this).attr('data-item-category');

        selectedFilters[category] = value.length > 0 ? value : null;

        clearTimeout(searchTimeout);

        searchTimeout = setTimeout(function () {
            search(e);
        }, 300);
    });

    function search(e) {
        e.preventDefault();

        $('#pagination').html('');

        const s = selectedFilters.s;
        const isReel = bjntFilter.resource === 'reel';
        const gridSelector = isReel ? '.bjnt-reel-grid' : '.bjnt-album-grid';

        if (previousRequest && previousRequest.readyState !== 4) {
            previousRequest.abort();
        }

        previousRequest = $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'bjnt_search',
                s: s,
                resource: bjntFilter.resource,
            },
            success: function (response) {
                if (response.success && response.data?.results?.length) {
                    const markup = response.data.results.map((item) => {
                        const title = escapeHtml(item.title || '');
                        const link = item.link || '#';
                        const thumbnail = item.thumbnail || '';
                        const alt = escapeHtml(item.alt || item.title || '');

                        if (isReel) {
                            return `
                <article class="bjnt-reel-card blog-item-masonry reel">
                  <a href="${link}" class="bjnt-reel-card__link">
                    <div class="bjnt-reel-card__media">
                      <img src="${thumbnail}" alt="${alt}">
                      <span class="bjnt-reel-card__play">
                        <i class="ri-play-fill"></i>
                      </span>
                    </div>

                    <div class="bjnt-reel-card__body">
                      <span class="bjnt-reel-card__label">Reel</span>
                      <h3>${title}</h3>
                    </div>
                  </a>
                </article>
              `;
                        }

                        return `
              <article class="bjnt-album-card blog-item-masonry album">
                <a href="${link}" class="bjnt-album-card__link">
                  <div class="bjnt-album-card__media">
                    <img src="${thumbnail}" alt="${alt}">
                  </div>

                  <div class="bjnt-album-card__body">
                    <span class="bjnt-album-card__label">Album</span>
                    <h3>${title}</h3>

                    <span class="bjnt-album-card__arrow">
                      <i class="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </a>
              </article>
            `;
                    }).join('');

                    const $grid = $(gridSelector);

                    if ($grid.data('isotope')) {
                        $grid.isotope('destroy');
                    }

                    $grid.html(markup);

                    $grid.imagesLoaded(function () {
                        $grid.isotope({
                            itemSelector: '.blog-item-masonry',
                            layoutMode: 'masonry',
                            percentPosition: true,
                            masonry: {
                                columnWidth: '.blog-item-masonry',
                                gutter: 22,
                            },
                        });
                    });

                    const countData = response.data.countData;

                    if (countData?.pgs?.max > 1) {
                        renderPagination(countData);
                    }
                } else {
                    const $grid = $(gridSelector);

                    if ($grid.data('isotope')) {
                        $grid.isotope('destroy');
                    }

                    $grid.html(`
            <div class="bjnt-empty-state blog-item-masonry">
              <h3>No ${escapeHtml(bjntFilter.archive)} found.</h3>
              <p>Try another search term.</p>
            </div>
          `);
                }
            },
            error: function (xhr, status, error) {
                if (status !== 'abort') {
                    console.error(error);
                }
            },
        });
    }

    function renderPagination(countData) {
        const current = parseInt(countData.pgs.currentpage, 10);
        const max = parseInt(countData.pgs.max, 10);

        const previous = current > 1
            ? `
        <button type="button" class="bjnt-pagination__btn pg-nav" data-page="${current - 1}">
          <i class="ri-arrow-left-line"></i>
          Previous
        </button>
      `
            : '';

        const next = current < max
            ? `
        <button type="button" class="bjnt-pagination__btn pg-nav" data-page="${current + 1}">
          Next
          <i class="ri-arrow-right-line"></i>
        </button>
      `
            : '';

        $('#pagination').html(`
      ${previous}
      <span class="bjnt-pagination__count">Page ${current} of ${max}</span>
      ${next}
    `);
    }

    $('body').on('click', '.pg-nav', function () {
        const page = parseInt($(this).attr('data-page'), 10);

        if (!page || page < 1) return;

        let url = generateURL();

        if (page > 1) {
            if (/\/page\/\d+\/?/.test(url)) {
                url = url.replace(/\/page\/\d+\/?/, `/page/${page}/`);
            } else {
                url = url.replace(/\/?$/, `/page/${page}/`);
            }
        } else {
            url = url.replace(/\/page\/\d+\/?/, '/');
        }

        const paramString = generateUrlParams();

        if (paramString) {
            url += paramString;
        }

        window.location.href = url;
    });

    function generateUrlParams() {
        const filters = [];

        for (const filter in selectedFilters) {
            if (selectedFilters[filter]?.length > 0) {
                filters.push(`${filter}=${encodeURIComponent(selectedFilters[filter])}`);
            }
        }

        return filters.length ? `?${filters.join('&')}` : '';
    }

    function generateURL() {
        let url = `${location.protocol}//${location.host}`;
        const path = location.pathname;
        const archive = bjntFilter.archive;

        const archiveRegex = new RegExp(`^/${archive}/?`);

        if (path && archiveRegex.test(path)) {
            url += path;

            if (!url.endsWith('/')) {
                url += '/';
            }
        } else {
            url += `/${archive}/`;
        }

        return url;
    }

    function setSelectedItem(val, cat) {
        if (cat === 's') {
            selectedFilters[cat] = val;
            $(`input[data-item-category=${cat}]`).val(val);
        }
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
});

jQuery(($) => {
    const $grid = $('.layout-masonry');

    if (!$grid.length) return;

    $grid.imagesLoaded(function () {
        $grid.isotope({
            itemSelector: '.blog-item-masonry',
            layoutMode: 'masonry',
            percentPosition: true,
            masonry: {
                columnWidth: '.blog-item-masonry',
                gutter: 22,
            },
        });
    });
});